<template>
  <div class="common-space-between container">
       <navBtnBlock></navBtnBlock>
       <div class="right-div" :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.ResetrouterNavWidth-this.$store.state.indexPadding*2)+"px",
                     height:(this.$store.state.windowHeight-130)+"px"
            }'>
           <ShowBtns/>

           <div class="warp-btn">
              <div class="common-items-center">

                  <InputBlock title="接口名称" >
                      <el-input v-model="name" :size="this.$store.state.inputSize" placeholder="请输入接口名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                  </InputBlock>
                  <InputBlock title="接口URL" >
                      <el-input v-model="url" :size="this.$store.state.inputSize" placeholder="请输入接口URL" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                  </InputBlock>
                   <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
                   <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
                </div>
               <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
               
           </div>
           <div class="warp-table">
            <el-table ref="giftTable" :data="tableData"  :empty-text="this.$store.state.tableEmpty" style="width: 100%" :size="this.$store.state.tableSize" row-key="id"  :height="this.$store.state.windowHeight-210" lazy   :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
               <el-table-column  prop="name"  label="接口名称"  ></el-table-column>
               <el-table-column  prop="method"  label="请求类型"  width="120">
                <template slot-scope="scope">
                  <span v-if="!scope.row.method">--</span>
                  <span v-else>{{scope.row.method}}</span>
                </template>  
               </el-table-column>
               <el-table-column  prop="method"  label="URL"  width="260">
                <template slot-scope="scope">
                  <span v-if="!scope.row.url">--</span>
                  <span v-else>{{scope.row.url}}</span>
                </template>  
               </el-table-column>
               <el-table-column :show-overflow-tooltip="true" align="center" header-align="center" prop="example" label="案列" width="100">
                    <template slot-scope="scope">
                      <span v-if='!scope.row.example'>-</span>
                      <div v-else class="warp-input">
                          <el-popover
                              placement="right"
                              width="400"
                              trigger="hover">
                              <div>
                                  <el-input v-model.number="scope.row.example" readonly  type="textarea" :autosize="{ minRows: 8, maxRows: 16}" autocomplete="off"></el-input>
                              </div>
                              <i class="el-icon-view" slot="reference"></i>
                          </el-popover>
                      </div>
                    </template>
               </el-table-column>
               <el-table-column :show-overflow-tooltip="true" prop="operator" label="操作人" width="250" align="center" header-align="center">
                 <template slot-scope="scope">
                      {{ scope.row.operator || "-" }}
                 </template>
               </el-table-column>
               <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="250" align="center" header-align="center"></el-table-column>
               <el-table-column :show-overflow-tooltip="true" prop="createTime" label="操作"  width="100" fixed="right"  align="center" header-align="center">
                  <template slot-scope="scope">
                      <div class="common-space-around operate">
                          <el-link :underline="false"  type="primary"  size="mini" @click="editorBtn(scope.row)" >编辑</el-link>
                          <el-popconfirm  icon-color="red" title="确定删除吗?" @confirm="deleteBtn(scope.row)"  >
                              <el-link :underline="false" slot="reference"  size="mini"  type="danger">删除</el-link>
                          </el-popconfirm>
                      </div>
                  </template>
               </el-table-column>
            </el-table>
           </div>
       </div>
       <AddIntef ref="add"></AddIntef>
       <EidtIntef ref="eidt"></EidtIntef>
  </div>
</template>
<script>
import { scroll } from '@/components/component-mixin/block-scroll'
import navBtnBlock from './common-module/navBtn-block.vue'
import AddIntef from './add-block-menu.vue'
import EidtIntef from './eidt-block-menu.vue'
import {url,operate} from '@/utils/config'
import {postFun,deleteFun} from '@/utils/httpFun'
import {setRouterNav} from '@/utils/util'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
      navBtnBlock:navBtnBlock,
      AddIntef:AddIntef,
      EidtIntef:EidtIntef,

  },
  data:()=>({  
    name:null,
    url:null,
    tableData: [{}],
    menuList:[],
    interfaceList:[],
    eidtParms:{},   
  }),
  created(){
    setRouterNav()
  },
  methods:{

    //来源于子组件
    getList(ev){
       
       this.code = ev.code
       this.subsystemId = ev.id
       this.getDatas()
    },

    //获取所有的接口文档
    async getDatas(){
        let parms = {
            subsystemId:this.subsystemId,  //平台的ID
            name:this.name,
            url:this.url,
        }
        await postFun(operate.JIEKOULIST,parms,res=>{
          let list =  !res.data ? []:res.data
          let newList = []
              for(var i in list){
                 if(list[i].type!=3){
                  newList.push(list[i])
                 }
              }
          this.tableData = newList      
        })
    },
    
    //获取参数
    getValParms(ev){
        this[ev.key] = ev.val
    },
    //搜索
    searchBtn(){
        this.getDatas()
    },
    
    //重置
    resetBtn(){
        this.name=null
        this.url = null
        this.getDatas()
    },

    //新增接口
    addBtn(){
       let parms = {
           subsystemId:this.subsystemId,
           systemCode:this.code,
           menuList:[...[{id:"0",name:"主目录"}],...this.tableData]
       }
       this.$refs.add.showBlockFun(parms);
    },

    //编辑菜单弹窗
    editorBtn(ev){
      let parms = {
           subsystemId:this.subsystemId,
           systemCode:this.code,
           val:ev,
           menuList:[...[{id:"0",name:"主目录"}],...this.tableData]
       }
       this.$refs.eidt.showBlockFun(parms);
    },

    //删除数据
    async deleteBtn(ev){
      await deleteFun(operate.JIEKOUDELETE+"/"+ev.id+"/"+ev.systemCode,{},res=>{
          this.getDatas()
      })
    }
  }
}
</script>
<style lang="scss" scoped>

   .right-div{
       position: relative;
       border: 1px solid rgba(240,240,240,0.2);
       box-shadow: -3px 3px 9px 0px rgba(205,216,233,0.2);
       padding:15px 15px 15px 15px;
       box-sizing: border-box;
       ::v-deep .el-table::before{
          height: 0;
       }
       ::v-deep .el-table__fixed-right::before, .el-table__fixed::before{
          height: 0;
       }
       .warp-btn{
         display: flex;
         justify-content: space-between;
       }
       .warp-table{
          padding-top:15px;
       }
       .operate{
          ::v-deep .el-button--mini{
            padding: 5px 8px;
          }
        }
    }
</style>
